import { HubPersona, uniq, flatten, PersonType } from '../../shared';

function personaContactsIdsFromFolderId(hubPersona: HubPersona, fromFolderId: string): string[] {
    return hubPersona.type === PersonType.Person && hubPersona.linkedContacts
        ? hubPersona.linkedContacts
              .filter(contact => contact.sourceFolderId === fromFolderId)
              .map(contact => contact.sourceId)
        : [];
}

export function personaIdsFromFolderId(hubPersona: HubPersona, fromFolderId: string): string[] {
    return hubPersona.type === PersonType.PrivateDistributionList
        ? [hubPersona.itemId]
        : personaContactsIdsFromFolderId(hubPersona, fromFolderId);
}

export function personasContactsIdsFromFolderId(
    hubPersonas: HubPersona[],
    fromFolderId: string
): string[] {
    return uniq(
        flatten(hubPersonas.map(hubPersona => personaIdsFromFolderId(hubPersona, fromFolderId)))
    );
}
